import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiTwitter, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-primary text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">

        {/* Logo & Description */}
        <div>
          <h2 className="text-2xl font-bold mb-3">
            Téranga <span className="text-secondary">Mode</span>
          </h2>
          <p className="text-gray-300 text-sm leading-relaxed">
            La boutique en ligne de mode africaine au Sénégal.
            Boubous, bazin, wax et bien plus, livres partout au Sénégal.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="#" className="text-gray-300 hover:text-secondary transition">
              <FiFacebook size={20} />
            </a>
            <a href="#" className="text-gray-300 hover:text-secondary transition">
              <FiInstagram size={20} />
            </a>
            <a href="#" className="text-gray-300 hover:text-secondary transition">
              <FiTwitter size={20} />
            </a>
          </div>
        </div>

        {/* Liens */}
        <div>
          <h3 className="font-semibold text-lg mb-4">Navigation</h3>
          <ul className="space-y-2 text-gray-300 text-sm">
            <li><Link to="/" className="hover:text-secondary transition">Accueil</Link></li>
            <li><Link to="/catalogue" className="hover:text-secondary transition">Catalogue</Link></li>
            <li><Link to="/panier" className="hover:text-secondary transition">Panier</Link></li>
            <li><Link to="/mes-commandes" className="hover:text-secondary transition">Mes commandes</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-semibold text-lg mb-4">Contact</h3>
          <ul className="space-y-3 text-gray-300 text-sm">
            <li className="flex items-center gap-2">
              <FiMapPin size={16} className="text-secondary" />
              Thies, Senegal
            </li>
            <li className="flex items-center gap-2">
              <FiMail size={16} className="text-secondary" />
              contact@terangamode.sn
            </li>
            <li className="flex items-center gap-2">
              <FiPhone size={16} className="text-secondary" />
              +221 77 000 00 00
            </li>
          </ul>
        </div>

      </div>
      <div className="border-t border-blue-800 text-center py-4 text-gray-400 text-sm">
        © 2026 Téranga Mode. Tous droits réservés. Développé par Momar DIOP.
      </div>
    </footer>
  );
};

export default Footer;